export default "__VITE_ASSET__c95315a5__"